/**
 * consoleCapture.js
 * Intercepts console.error and console.warn to keep a ring buffer
 * of the last MAX_ENTRIES entries. Import and call install() once at boot.
 * Read logs anytime with getLogs().
 */

const MAX_ENTRIES = 20;
const logs = [];

let installed = false;

export function install() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  ["error", "warn"].forEach((level) => {
    const original = console[level].bind(console);
    console[level] = (...args) => {
      const message = args
        .map((a) => {
          try {
            return typeof a === "object" ? JSON.stringify(a) : String(a);
          } catch {
            return String(a);
          }
        })
        .join(" ")
        .slice(0, 300); // cap per-entry length

      logs.push({ level, message, ts: new Date().toISOString() });
      if (logs.length > MAX_ENTRIES) logs.shift();

      original(...args);
    };
  });
}

/** Returns a plain-text summary of captured logs, newest last. */
export function getLogs() {
  return logs
    .map((e) => `[${e.ts}] [${e.level.toUpperCase()}] ${e.message}`)
    .join("\n");
}
